import { connect } from 'react-redux'
import React from 'react'
import { withRouter } from 'react-router-dom'
import settings from 'settings'
import { Elements, StripeProvider } from 'react-stripe-elements'

// Components
import CheckoutForm from './CheckoutForm'

// Utils
import analytics from 'app/views/utils/analytics'


class Upgrade extends React.Component {
  componentDidMount() {
    analytics.page('page-upgrade')
  }

  render() {
    return (
      <div className="uk-background-muted" style={{ minHeight: 'calc(100vh - 80px)' }}>
        <StripeProvider apiKey={settings.stripe.key}>
          <Elements>
            <CheckoutForm email={this.props.profile.email} />
          </Elements>
        </StripeProvider>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  // profile
  profile: state.hacker.profile,
})

export default withRouter(connect(mapStateToProps)(Upgrade))
